"use client"

import styles from "./styles.module.scss";
import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { useRouter } from "next/navigation";

declare const window: any;

// const Custom500 = () => 
// {
//     return (
//         <main className={styles.page500}>
//             <div className={styles.info}>
//                 <h1>PÁGINA NÃO ENCONTRADA</h1>
//                 <p>LAMENTAMOS, MAS ESTA PÁGINA JÁ NÃO ESTÁ DISPONÍVEL NO NOSSO SITE.</p>
//                 <button onClick={() => router.push("/")}>
// 					Voltar à página principal
//                 </button>
//             </div>
//         </main>
//     );
// };

export default function Custom500({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
  }) 
{
    const router = useRouter();

    useEffect(() => 
    {
        Sentry.captureException(error);
        // Log the error to an error reporting service
        console.error(error)
    }, [ error ])

    return (
        <main className={styles.page500}>
            <div className={styles.info}>
                <h1>PÁGINA NÃO ENCONTRADA</h1>
                <p>LAMENTAMOS, MAS ESTA PÁGINA JÁ NÃO ESTÁ DISPONÍVEL NO NOSSO SITE.</p>                
                <button onClick={() => router.push("/")}>
					Voltar à página principal
                </button>
            </div>
        </main>
    )
}

export { Custom500 };
